//时间格式转换:
//一分钟以内 显示刚刚
//超过一分钟 显示今天 hh:mm
//昨天 显示昨天 hh:mm
//超过两天 几月几日
//跨年 yyyy年几月几日

import {
  format,
  isYesterday,
  isToday,
  isThisYear,
  getHours
} from 'date-fns';

export const customDateStr = (ts: number) => {
  let date = '';
  if(!isThisYear(ts)) {
    date = format(ts, 'yyyy') + '/' + format(ts, 'MM') + '/' + format(ts, 'dd');
  }else {
    if(isToday(ts)) {
      const hour = getHours(ts);
      const time = format(ts, 'HH:mm');
      if(hour <= 12) {
        date = '上午' + time;
      }else {
        date = '下午' + time;
      }
    }else if(isYesterday(ts)) {
      date = '昨天';
    }else {
      date = format(ts, 'MM') + '/' + format(ts, 'dd');
    }
  }
  return date;
};
